export const APP_NAME = 'Shesha Boilerplate';

export const ACCESS_TOKEN_NAME = 'xDFcxiooPQxazdndDsdRSerWQPlincytLDCarcxVxv';

/**
 * The header form this app renders.
 *
 * Shesha's MainLayout defaults to `{ name: 'header', module: 'Shesha' }`, which is owned by the
 * framework module and is rewritten on every boot - a customisation made there is reverted.
 * Telephony's header carries a ShaTelephony component, so the form is exposed into this app's own
 * module and referenced explicitly here.
 */
export const HEADER_FORM = { name: 'header', module: 'Shesha.Telephony' } as const;
